import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SafeHtml } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

// TODO:
// To be standalone, requires standalone:
// - SimpleLangSwitchComponent
@Component({
  selector: 'customer-app-equity-legal-disclaimer',
  templateUrl: './equity-legal-disclaimer.component.html',
  styleUrls: ['./equity-legal-disclaimer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class EquityLegalDisclaimerComponent {
  private dialogRef = inject<MatDialogRef<EquityLegalDisclaimerComponent>>(MatDialogRef);
  private translateService = inject(TranslateService);

  getTranslation(translateString): string | SafeHtml {
    return this.translateService.instant(translateString);
  }

  static openDialog(dialog: MatDialog): MatDialogRef<EquityLegalDisclaimerComponent> {
    return dialog.open<EquityLegalDisclaimerComponent, undefined, boolean>(EquityLegalDisclaimerComponent, {
      maxWidth: '880px',
      width: '100%',
      minWidth: '375px',
      height: '80vh',
      disableClose: true
    });
  }

  confirm(): void {
    this.dialogRef.close(true);
  }

  close(): void {
    this.dialogRef.close();
  }
}
